import { CustomEntityService } from './apiclient/api/customEntity.service';
import { UserSessionService } from './UserSession/user-session.service';
import { Injectable } from '@angular/core';
import { CustomEntityFull } from './apiclient/model/customEntityFull';
import { LocalDataSource } from 'ng2-smart-table';
import { CustomformsService } from './apiclient/api/customforms.service';
import { CustomForm } from './apiclient/model/customForm';
import { Observable, Subscriber } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomFormUtilsService {

  private entities: CustomEntityFull[];
  private subforms: CustomForm[];
  private ineditionCompany;
  private propertiesDataSource: LocalDataSource

  constructor(private userSessionService: UserSessionService,
              private entityService: CustomEntityService,
              private formsService: CustomformsService) { }


   public editingCompany(idcompany){
    this.ineditionCompany = idcompany;
    this.entities = null
    this.getCompanyEntities()
  }

  public setPropertiesDataSource(source){
    this.propertiesDataSource = source;
  }

  async getCompanyEntities(){

    if(null == this.entities){
      this.entities = await this.entityService.customEntitiesByCompany(this.ineditionCompany,this.userSessionService.accessToken).toPromise();
    }
    return this.entities;
  }
  getCompanySubforms(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.userSessionService.getCustomForms().subscribe(
        (forms) => {
          this.subforms = forms.filter(s => s.company_id === parseInt(this.ineditionCompany));
          resolve(this.subforms);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

   getEntityName(entityid){
    if(this.entities != undefined){
      return this.entities.filter(entity => entity.id === entityid)[0].name;
    }
  }

  async getFormFieldList(){
    var formRows = await this.propertiesDataSource.getAll()
    return formRows.map(row => {
      return row.id
    })
  }

  async getFormFieldTypeList(){
    var formRows = await this.propertiesDataSource.getAll()
    return formRows.map(row => {
      return { id: row.id, type: row.type };
    })
  }

  async getEntityFromField(fieldId){
    //Obtenemos el campo del customform
    var fieldIdParts = fieldId.split(".");
    var customformField = (await this.propertiesDataSource.getAll()).find(f => f.id == fieldId);
    if(fieldIdParts.length > 1){

      customformField = (await this.propertiesDataSource.getAll()).find(f => f.id == fieldIdParts[0]);
      var subform =  (await this.getCompanySubforms()).find(a => a.id == customformField.subformConfig.id);

      customformField = subform.dynamic_form.Fields.find(f => f.id == fieldIdParts[1])

    }


    if(customformField != undefined){
      if(customformField.customEntityConfig != undefined){
        //Obtenemos la entidad
       // this.getCompanyEntities()
        var entity =  (await this.getCompanyEntities()).find(e => e.id == customformField.customEntityConfig.entity);
        return entity;
      }else{
        throw('El campo ' + fieldId + ' no es de tipo customentity');
      }
    }else{
      throw('El campo ' + fieldId + ' no es de tipo customentity');
    }
  }


  async getSubformFromField(fieldId, vType){
    //Obtenemos el campo del customform
    var customSubformField = (await this.propertiesDataSource.getAll()).filter(r => r.type == 'subform').find(f => f.id == fieldId);
    if(customSubformField != undefined){
      if(customSubformField.subformConfig != undefined){
        //Obtenemos los campos del subform
        var subform = (await this.getCompanySubforms()).filter(a => a.id == customSubformField.subformConfig.id).map(b => b.dynamic_form).map(c => c.Fields)
        var entitiesListFromSubform = subform.flatMap(subform => subform.filter(element => element.type === vType))
                         .map(element => element.id);
        //Obtenemos los campos de tipo customentitylist de ese subformulario
        return entitiesListFromSubform;
      }else{
        throw('El campo ' + fieldId + ' no es de tipo subform');
      }
    }else{
      throw('El campo ' + fieldId + ' no es de tipo subform');
    }
  }

  async getIdSubformFromField(fieldId){
    //Obtenemos el campo del customform
    var customSubformField = (await this.propertiesDataSource.getAll()).filter(r => r.type == 'subform').find(f => f.id == fieldId);
    if(customSubformField != undefined){
      if(customSubformField.subformConfig != undefined){
        //Obtenemos los campos del subform
        var subform = (await this.getCompanySubforms()).filter(a => a.id == customSubformField.subformConfig.id).map(b => b.dynamic_form).map(c => c.Fields)
        var customEntity = subform.flatMap(subform => subform.filter(element => element.type === "customentity_list"))
                         .map(element => element.customEntityConfig);
        return customEntity[0].entity;
      }else{
        throw('No existe el campo de tipo customentitylist del subformulario');
      }
    }else{
      throw('No existe el campo de tipo customentitylist del subformulario');
    }
  }

}
